import _ from 'underscore'
import FormView from './form'
import ForgottenPasswordViewTemplate from '../templates/forgotten-password.tpl'
import messages from '../messages'
import Request from '../helpers/request'
import Alert from '../helpers/alert'
import Backbone from 'backbone'

const ForgottenPasswordView = FormView.extend({
    events: {
        'click .close': 'close',
        'click .submit': 'sendResetEmail',
    },
    initialize() {
        this.template = _.template(ForgottenPasswordViewTemplate)
    },
    sendResetEmail() {
        const email = this.$el.find('#email').val()

        new Promise((resolve, reject) => {
            // checks if name is blank
            if (email.trim() === '') {
                reject(messages.MSG_EMAIL_BLANK)
            }
            resolve()
        })
            .then(() => Request({
                url: '/api/password/reset',
                method: 'POST',
                data: {
                    email: email,
                }
            }))
            .then((response) => {
                this.close()
                if (response && response.message) {
                    Alert(response.message)
                }
            })
            .catch(Alert)
    },
    close() {
        Backbone.history.navigate('school', {trigger: true})
    }
})

export default ForgottenPasswordView